import { TuiIcon } from '@taiga-ui/core';
import { TuiTooltip } from '@taiga-ui/kit';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WorkflowFormFieldOutputRequestCommentsPopulated } from '@features/requests/request-form/components/request-form-workflows/types';

@Component({
  selector: 'x-output-request-comments',
  imports: [CommonModule, TuiTooltip, TuiIcon],
  templateUrl: './output-request-comments.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'block' },
})
export class OutputRequestCommentsComponent {
  field = input.required<WorkflowFormFieldOutputRequestCommentsPopulated>();
}
